import { scene } from '../main/scene-sidecar'
import { tileMapShipAStarGridMaker } from '../tiles/tileMapShipAStarGridMaker-sidecar'
import { IPathResult } from '../astar/astarInterface'
import { IPathNode } from './PathFinder2'
import { TestWorker2 } from './TestWorker2-sidecar'

let findPathId = 0
export const findPath = (
  sx: number,
  sy: number,
  sz: number,
  ex: number,
  ey: number,
  ez: number,
  allowNextTo: boolean,
  callback: (result: {
    findPathId: number
    result: IPathResult<IPathNode>
  }) => void,
) => {
  console.log('finding path', sx, sy, sz, ex, ey, ez)
  findPathId++
  let ctx = scene.getContext()

  let grid = tileMapShipAStarGridMaker.createAStarGrid(ctx.mapShip)

  TestWorker2.call(
    'find-path-2',
    {
      sx,
      sy,
      sz,
      ex,
      ey,
      ez,
      allowNextTo,
      grid,
      findPathId: findPathId,
    },
    (result: { findPathId: number; result: IPathResult<IPathNode> }) => {
      if (callback) {
        callback(result)
      }
    },
  )

  return findPathId
}
